import React, { useEffect, useState, useContext, useCallback } from "react";
import AuthContext from "../../context/AuthContext";
import { Button, Modal, Container, Col, Form } from "react-bootstrap";
import swal from "sweetalert";
import { updateOneVisitaService } from "../../utils/VisitasService";

function VerDeudoresModal({ visitas, setVisitas }) {
  const { authTokens } = useContext(AuthContext);

  // States del Modal
  const [show, setShow] = useState(false);
  const [deudores, setDeudores] = useState([]);
  const [formaDePago, setFormaDePago] = useState("Efectivo");

  // Handlers para abrir y cerrar.
  const handleClose = () => setShow(false);

  const handleShow = () => {
    const aux = visitas.filter((visita) => visita.formaDePago == "Debe");
    setDeudores(aux);
    setShow(true);
  };

  // Actualizamos la Visita en la db (la deuda ha sido pagada)
  const updateVisita = useCallback(async (id) => {
    let request = { id: id, formaDePago: formaDePago };
    updateOneVisitaService(request, authTokens).then((response) => {
      // Chequeamos si la respuesta fue 'OK 200'
      if (response.status === 200) {
        setDeudores(deudores.filter((visita) => visita.id_visita !== id));

        let visitaPagada = deudores.filter((visita) => visita.id_visita === id);
        visitaPagada[0]["formaDePago"] = formaDePago;

        let aux = visitas.map((visita) =>
          visita.id_visita === id ? visitaPagada[0] : visita
        );
        setVisitas(aux);
      }
    });
  });

  // Confirmacion antes de llamar a 'updateVisita'
  function confirmUpdate(id) {
    swal({
      title: "Actualizar la Visita?",
      icon: "warning",
      buttons: {
        cancel: "Cancelar",
        catch: "Actualizar",
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        updateVisita(id);
      }
    });
  }

  return (
    <>
      <Button variant="danger" size="sm" onClick={handleShow}>
        Ver deudores
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>Visitas sin cobrar</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {deudores.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th className="col-lg-2">Fecha</th>
                      <th className="col-lg-3">Cliente</th>
                      <th className="col-lg-2">Debe</th>
                      <th className="col-lg-3">Forma de pago</th>
                      <th className="col-lg-1">Accion</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deudores.map((visita) => {
                      return (
                        <tr key={visita.id_visita} className="table-default">
                          <td>{visita.fecha}</td>
                          <td>
                            {visita.nombre} {visita.apellido}
                          </td>
                          <td>${visita.total}</td>
                          <td>
                            <Form.Select
                              onChange={(e) => {
                                setFormaDePago(e.target.value);
                              }}
                            >
                              <option value={"Efectivo"}>Efectivo</option>
                              <option value={"Transferencia"}>
                                Transferencia
                              </option>
                              <option value={"Tarjeta"}>Tarjeta</option>
                            </Form.Select>
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-dark btn-sm"
                              onClick={() => {
                                confirmUpdate(visita.id_visita);
                              }}
                            >
                              Cobrar
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <h5>No hay deudores</h5>
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" size="sm" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VerDeudoresModal;
